import {useSelector} from 'react-redux';
import authFetch from '../../../helpers/requests';
import {get} from 'components/api';

const urlCourseContents = '/CourseManager/GetCourseContent';
const urlInitContent = '/CourseManager/InitContent';
const urlUpdateAttempt = '/CourseManager/UpdateAttempt';
const urlSaveResult = '/CourseManager/SaveResult';
const urlUpdateContent = '/CourseManager/UpdateContent';
const urlSignCourse = '/CourseManager/SignCourse';
const urlValidateInstructor = '/CourseManager/ValidateInstructor';

export function getCourseContents(
  iD_Course: number,
  iD_Instance: number,
  cwid: string,
  token: string,
) {
  // return useLoadAdditional(urlCourseContents, JSON.stringify({ iD_Course, employee_Nr }));
  const additional = JSON.stringify({iD_Course, iD_Instance, cwid});
  const url = `${urlCourseContents}?additional=${additional}`;
  return get(url, token);
}

export function initContent(
  iD_Course: number,
  iD_Content: number,
  iD_Instance: number,
  cwid: string,
  type: number,
  token: string,
) {
  const data = JSON.stringify(
    JSON.stringify({iD_Course, iD_Content, iD_Instance, cwid, type}),
  );
  return authFetch(
    `${urlInitContent}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
    },
    token,
  );
}

export function saveResult(
  iD_Course: number,
  iD_Content: number,
  iD_Instance: number,
  employee_Nr: number,
  attempt: number,
  iD_Choice: number,
  correct: boolean,
  token: string,
) {
  const data = JSON.stringify(
    JSON.stringify({
      iD_Course,
      iD_Content,
      iD_Instance,
      employee_Nr,
      attempt,
      iD_Choice,
      correct,
    }),
  );
  return authFetch(
    `${urlSaveResult}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
    },
    token,
  );
}

export function updateAttempt(
  iD_Course: number,
  iD_Instance: number,
  cwid: string,
  pass: string,
  token: string,
  lateReason: number | null,
  descriptionLateReason: string,
) {
  const data = JSON.stringify(
    JSON.stringify({
      iD_Course,
      iD_Instance,
      lateReason,
      descriptionLateReason,
      cwid,
      pass,
    }),
  );
  return authFetch(
    `${urlUpdateAttempt}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
    },
    token,
  );
}

export function updateContent(
  iD_Course: number,
  iD_Content: number,
  iD_Instance: number,
  employee_Nr: number,
  attempt: number,
  token: string,
) {
  const data = JSON.stringify(
    JSON.stringify({iD_Course, iD_Content, iD_Instance, employee_Nr, attempt}),
  );
  return authFetch(
    `${urlUpdateContent}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
    },
    token,
  );
}

export function signCourse(
  cwid: string,
  pass: string,
  iD_Course: number,
  iD_Instance: number,
  token: string,
) {
  const data = JSON.stringify(
    JSON.stringify({cwid, pass, iD_Course, iD_Instance}),
  );
  return authFetch(
    `${urlSignCourse}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
    },
    token,
  );
}

export function validateInstructor(cwid: string, pass: string, token: string) {
  const data = JSON.stringify(JSON.stringify({cwid, pass}));
  return authFetch(
    `${urlValidateInstructor}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
    },
    token,
  );
}

export function useTabletCourse() {
  const tabletCourse = useSelector((state: any) => state.TabletCourseReducer);
  return {tablet: tabletCourse.tablet, assistants: tabletCourse.assistants};
}
